import React, { Suspense, useEffect } from 'react';
import { Router } from 'react-router-dom';
// import ReactGA from 'react-ga';
// import forEach from 'lodash/forEach';
// import { Detector } from 'react-detect-offline';
// import EventConstants from './constants/EventConstants';
// import WebCamera from './components/WebCamera';
// import InternetState from './components/InternetState';
// import TelemetryService from './services/TelemetryService';
// import VideoPlay from './components/VideoPlay';
// import StorageConstants from './constants/StorageConstants';
// import GlobalStorageService from './services/GlobalStorageService';
// import APIService from './services/APIService';

import AppContext from './contexts';
import History from './modules/Navigation/lib/History';
import './styles/global.scss';
import AppRoute from './routes';
import { getUserDetailsById } from './services/API/MarketplaceService';
// import { useTranslation } from 'react-i18next';
import i18n from './i18n';

// function handleConnectivityChange(isConnected) {
//   GlobalStorageService.setItem(StorageConstants.IS_INTERNET_CONNECTED, isConnected);
//   if (isConnected) {
//     window.pendingAPIS &&
//       window.pendingAPIS.length < 5 &&
//       forEach(window.pendingAPIS, api => {
//         APIService.request(api.options, api.cb);
//       });
//     window.pendingAPIS = [];
//   }
// }

function App() {
  // const [webCameraSettings, setWebCameraSettings] = useState({});

  // const inputFile = useRef(null);

  // useEffect(() => {
  //   const unSubscribeWebCamera = window.eventemitter.subscribe(
  //     EventConstants.eventNames.WEB_CAMERA,
  //     webCameraSetting => {
  //       setWebCameraSettings(webCameraSetting);
  //     }
  //   );
  //   const unSubscribeFile = window.eventemitter.subscribe(
  //     EventConstants.eventNames.WEB_FILE,
  //     fileSettings => {
  //       if (fileSettings.openFile) {
  //         inputFile.current.click();
  //       }
  //     }
  //   );
  //
  //   TelemetryService.setUser();
  //   return () => {
  //     unSubscribeWebCamera();
  //     unSubscribeFile();
  //   };
  // }, []);

  useEffect(() => {
    History.listenNavigation();
  }, []);

  useEffect(() => {
    // ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID, { siteSpeedSampleRate: 100 });
    // const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnetion;
    // ReactGA.event({
    //   category: 'Performance',
    //   action: 'NETWORK_STATUS',
    //   label: connection ? connection.effectiveType : 'NA',
    //   value: connection ? connection.downLink : 0,
    //   nonInteraction: true,
    // });

    if (localStorage.getItem('userId')) {
      getUserDetailsById(localStorage.getItem('userId'))
        .then(response => {
          const responseObj = response.data;
          responseObj.preferredLanguage
            ? i18n.changeLanguage(responseObj.preferredLanguage)
            : i18n.changeLanguage('en');
          localStorage.setItem(
            'preferredLanguage',
            responseObj.preferredLanguage ? responseObj.preferredLanguage : 'en'
          );
          window.activeLanguage = responseObj.preferredLanguage
            ? responseObj.preferredLanguage
            : 'en';
        })
        .catch(err => {
          // if API breaks then if a language resides in locastorage, use that
          // if (localStorage.getItem('preferredLanguage')) {
          //   i18n.changeLanguage(localStorage.getItem('preferredLanguage'));
          // }
          console.log(err);
        });
    }
  }, []);

  // const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  //   // eslint-disable-next-line no-undef
  //   const byteCharacters = atob(b64Data);
  //   const byteArrays = [];
  //
  //   for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
  //     const slice = byteCharacters.slice(offset, offset + sliceSize);
  //
  //     const byteNumbers = new Array(slice.length);
  //     // eslint-disable-next-line no-plusplus
  //     for (let i = 0; i < slice.length; i++) {
  //       byteNumbers[i] = slice.charCodeAt(i);
  //     }
  //
  //     const byteArray = new Uint8Array(byteNumbers);
  //     byteArrays.push(byteArray);
  //   }
  //
  //   const blob = new Blob(byteArrays, { type: contentType });
  //   return blob;
  // };

  // const onChangeFile = event => {
  //   const contentType = 'image/png';
  //   event.stopPropagation();
  //   event.preventDefault();
  //   if (event.target.value.length === 0) {
  //     window.eventemitter.emit(EventConstants.eventNames.WEB_FILE_ERROR, 'no files selected');
  //   } else {
  //     const file = event.target.files[0];
  //     const reader = new FileReader();
  //
  //     reader.onload = readerEvt => {
  //       const binaryString = readerEvt.target.result;
  //       // eslint-disable-next-line no-undef
  //       const base64 = btoa(binaryString);
  //       const blob = b64toBlob(base64, contentType);
  //       window.eventemitter.emit(EventConstants.eventNames.WEB_FILE_SUCCESS, {
  //         blob,
  //         base64,
  //         file,
  //       });
  //     };
  //     reader.readAsBinaryString(file);
  //   }
  // };
  return (
    <AppContext>
      <Router history={History}>
        <Suspense fallback={<Loader />}>
          <div className="App">
            {/* <input */}
            {/*  type="file" */}
            {/*  id="file" */}
            {/*  ref={inputFile} */}
            {/*  accept="image/*" */}
            {/*  style={{ display: 'none' }} */}
            {/*  onChange={onChangeFile} */}
            {/* /> */}
            {/* <VideoPlay history={History} /> */}
            {/* {webCameraSettings.openCamera && ( */}
            {/*  <Suspense fallback={<div />}> */}
            {/*    <WebCamera */}
            {/*      openCamera={webCameraSettings.openCamera || false} */}
            {/*      unSubscribeEvent={webCameraSettings.unSubscribeEvent} */}
            {/*      blobData={webCameraSettings.blobData || false} */}
            {/*      isSelfie={webCameraSettings.isSelfie || false} */}
            {/*    /> */}
            {/*  </Suspense> */}
            {/* )} */}
            <AppRoute />
            {/* <Detector
              render={({ online }) => (
                <div style={{ zIndex: 999, position: 'fixed', bottom: 0, left: 0, right: 0 }}>
                  {handleConnectivityChange(online)}
                  <InternetState isInternetConnected={online} showInternetStatus />
                </div>
              )}
            /> */}
          </div>
        </Suspense>
      </Router>
    </AppContext>
  );
}

const Loader = () => <div>loading...</div>;

export default App;
